
import api from '@/api/index'
import {Component, Vue} from "vue-property-decorator";
import {SplitAccountFeeDisplayConfigureDto} from "@/api/appService";

@Component({
  name: 'FeeDisplayNamesSetting'
})
export default class FeeDisplayNamesSetting extends Vue {

  form: SplitAccountFeeDisplayConfigureDto = {
    fee1DisplayName: '',
    fee2DisplayName: '',
    fee3DisplayName: '',
  }

  rules = {
    fee1DisplayName: [
      {required: true, message: '请输入固定费用1名称', trigger: 'blur'},
      {min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}
    ],
    fee2DisplayName: [
      {required: true, message: '请输入固定费用2名称', trigger: 'blur'},
      {min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}
    ],
    fee3DisplayName: [
      {required: true, message: '请输入固定费用3名称', trigger: 'blur'},
      {min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}
    ],
  }

  submitting = false;

  created(){
    api.storeSplitAccountReport.getFeeDisplayNames().then(value => {
      this.form.fee1DisplayName = value.fee1DisplayName;
      this.form.fee2DisplayName = value.fee2DisplayName;
      this.form.fee3DisplayName = value.fee3DisplayName;
    })
  }

  update(){

    (this.$refs.dataForm as any).validate((valid:boolean)=>{
      if(!valid){
        return;
      }

      this.submitting = true;
      api.storeSplitAccountReport.updateFeeDisplayNames({body:this.form}).then(()=> {
        this.submitting = false;
        this.$message.success('更新成功')
      }).catch(()=> {
        this.submitting = false;
      })

    })


  }

}
